import { createStyles, makeStyles } from '@mui/styles';
import { ITheme } from 'theme/types';

const useStyles = makeStyles((theme: ITheme) => ({
  section: {
    marginBottom: theme.spacing(3),
  },
}));

export default useStyles;
